import { Grid } from "@mui/material";
import { DisplayName, Plans } from "schemas/payments";

interface Props {
  plan: Plans;
}

const PlanStats = ({ plan }: Props) => {
  if (
    ![
      Plans.PRO,
      Plans.PRO_YEARLY,
      Plans.VA,
      Plans.VA_YEARLY,
      Plans.AUTOPILOT,
      Plans.AUTOPILOT_YEARLY,
    ]?.includes(plan)
  ) {
    return <></>;
  }

  const getMultiplier = () => {
    if (plan === Plans.PRO || plan === Plans.PRO_YEARLY) return 11;
    return 33;
  };

  return (
    <Grid item xs={12} sx={{ color: "#4A5565" }}>
      👉 {DisplayName[plan]} users are {getMultiplier()}x more likely to land a
      brand deal
    </Grid>
  );
};

export default PlanStats;
